/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-27 17:27:56
 * @LastEditors: K
 * @LastEditTime: 2022-08-05 10:13:05
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Modal,
  notification,
  Popconfirm,
  Row,
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './Tenants.module.css'
import { Checks, Settinglable } from '../../models/setting'
import { ReplaceMakeModal } from './replaceMakeModal'
import { getResectSettingLabel, selectReplaceOpentype } from './tenantSlice'
import {
  setAppShadeIsModal,
  setAppShadeTipText,
} from '../../layouts/layoutSlice'

export const ResetSettingModal = (props: {
  visible: boolean
  num?: any
  tenantIds?: any
  state?: any
  onCancel: () => void
  onOk: () => void
}): ReactElement => {
  const dispatch = useDispatch<any>()

  const [form] = Form.useForm()

  // 代煎设置
  const [isReplaceMakeModalVisible, setIsReplaceMakeModalVisible] = useState(
    false
  )
  const replaceMakeStatus = useSelector(selectReplaceOpentype)

  useEffect(() => {
    if (props?.visible) {
      const id = location.search.replace('?', '')
    }
  }, [props?.visible])

  return (
    <div>
      <Modal
        footer={null}
        width={1000}
        className={styles.resetSettingModal}
        title={'批量设置' + `${props?.num}` + '家机构的增值服务'}
        visible={props.visible}
        onCancel={() => {
          props.onCancel()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <div
          style={{
            height: 'calc(100% - 70px)',
            display: 'flex',
            flexDirection: 'column',
            background: '#FFFFFF',
            borderRadius: '10px',
            overflowY: 'scroll',
          }}
        >
          <Form
            labelAlign='right'
            initialValues={{ remember: true, [Checks.QF]: 'false' }}
            form={form}
            autoComplete='off'
            onFinish={(values) => {
              dispatch(setAppShadeIsModal(true))
              dispatch(setAppShadeTipText('正在处理中，请稍后~~~'))
              const pattern = /^[0-9]*$/
              const f = _.chain(values)
                .pickBy((_, k) => pattern.test(k))
                .mapValues(
                  (v, k) =>
                    ({
                      type: k,
                      value: v?.toString(),
                    } as Settinglable)
                )
                .values()
                .value()
              dispatch(
                getResectSettingLabel({
                  tenantIds: props?.tenantIds,
                  functionList: f,
                }) as any
              )
                .then(unwrapResult)
                .then(() => {
                  notification.success({
                    message: '操作成功',
                    duration: 3,
                  })
                  dispatch(setAppShadeIsModal(false))
                  dispatch(setAppShadeTipText('请稍后~~~'))
                  props.onOk()
                  form.resetFields()
                })
                .catch(() => {
                  dispatch(setAppShadeIsModal(false))
                  dispatch(setAppShadeTipText('请稍后~~~'))
                  notification.error({
                    message: '操作失败',
                    duration: 3,
                  })
                  props.onCancel()
                  form.resetFields()
                })
            }}
          >
            <Row
              style={{
                height: '40px',
                lineHeight: '40px',
                display: 'flex',
                alignItems: 'center',
                fontSize: '15px',
                fontWeight: 700,
                marginLeft: '20px',
                marginTop: '10px',
              }}
            >
              <i
                style={{
                  width: '2px',
                  height: '10px',
                  backgroundColor: '#0052D9',
                  margin: '-14px  10px 0 30px',
                }}
              ></i>
              <p>机构功能设置信息</p>
            </Row>
            <Row>
              <Col style={{ marginLeft: '70px' }}>
                <Form.Item
                  label='医生电子签名'
                  name={Checks.DZQM}
                  valuePropName='checked'
                >
                  <Checkbox>启用</Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col style={{ marginLeft: '70px' }}>
                <Form.Item
                  label='智能审方'
                  name={Checks.ZNSF}
                  valuePropName='checked'
                >
                  <Checkbox>启用</Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col style={{ marginLeft: '70px' }}>
                <Form.Item
                  label='商城'
                  name={Checks.LKSC}
                  valuePropName='checked'
                >
                  <Checkbox>启用</Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col style={{ marginLeft: '70px' }}>
                <Form.Item
                  label='辅助诊断'
                  name={Checks.ZNFZ}
                  valuePropName='checked'
                >
                  <Checkbox>启用</Checkbox>
                </Form.Item>
              </Col>
            </Row>
            {/* <Row>
              <Col style={{ marginLeft: '70px' }}>
                <Form.Item label='代煎设置'>
                  <Button
                    onClick={() => {
                      setIsReplaceMakeModalVisible(true)
                    }}
                    type='link'
                  >
                    {replaceMakeStatus == 1 ? '开通代煎' : '代煎选项设置'}
                  </Button>
                </Form.Item>
              </Col>
            </Row> */}
            <Row
              style={{
                display: 'flex',
                justifyContent: 'end',
                alignItems: 'center',
                margin: '20px 0px 0 0 ',
                paddingTop: '15px',
                borderTop: '1px solid #f0f0f0',
              }}
            >
              <div
                style={{
                  height: '50px',
                  marginRight: '10px',
                }}
              >
                <Button
                  onClick={() => {
                    props.onCancel()
                    form.resetFields()
                  }}
                >
                  取消
                </Button>
              </div>

              <div
                style={{
                  height: '50px',
                  marginRight: '10px',
                }}
              >
                <Popconfirm
                  placement='topRight'
                  title={
                    '本次操作将会覆盖' +
                    `${props?.num}` +
                    '家机构原来的增值业务，请确认！'
                  }
                  onConfirm={() => {
                    console.log(1)
                    form.submit()
                  }}
                  okText='确认'
                  cancelText='取消'
                >
                  <Button htmlType='submit' type='primary'>
                    确认
                  </Button>
                </Popconfirm>
              </div>
            </Row>
          </Form>
        </div>
        {/* 代煎 */}
        <ReplaceMakeModal
          state={props?.state}
          tenantIds={props?.tenantIds}
          replaceMakeId={location.search.replace('?', '') as any}
          visible={isReplaceMakeModalVisible}
          onOk={() => {
            setIsReplaceMakeModalVisible(false)
            props?.onOk()
          }}
          onCancel={() => {
            setIsReplaceMakeModalVisible(false)
          }}
        />
      </Modal>
    </div>
  )
}
